import { render, staticRenderFns } from "./FormsSkalyPred.vue?vue&type=template&id=3ebb4f7c&"
import script from "./FormsSkalyPred.vue?vue&type=script&lang=js&"
export * from "./FormsSkalyPred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports